import { z } from 'zod';
import { CalendarDateOnlySchema } from './common.js';
// =============================================================================
// Supplier Statement
// =============================================================================
// Order of the two bounds when both are present. `to` still defaults to today
// in the service, so a lone `from` after today is rejected there.
export const SupplierStatementQuerySchema = z
    .object({
    from: CalendarDateOnlySchema.optional(),
    to: CalendarDateOnlySchema.optional(),
})
    .refine((query) => query.from === undefined || query.to === undefined || query.from <= query.to, { message: "'from' must not be after 'to'", path: ['from'] });
export const SupplierStatementEntrySchema = z.object({
    id: z.string(),
    ledgerEntrySetId: z.string(),
    accountingDate: z.string(),
    description: z.string(),
    sourceReference: z.string().nullable(),
    supplierInvoiceId: z.string().nullable(),
    amountMinorUnits: z.number().int(),
    invoicedMinorUnits: z.number().int(),
    paidOrCreditMinorUnits: z.number().int(),
    runningBalanceMinorUnits: z.number().int(),
    amountOwedMinorUnits: z.number().int(),
});
export const SupplierStatementResponseSchema = z.object({
    supplier: z.object({
        id: z.string(),
        name: z.string(),
    }),
    period: z.object({
        from: z.string().nullable(),
        to: z.string(),
    }),
    currency: z.string(),
    openingBalanceMinorUnits: z.number().int(),
    closingBalanceMinorUnits: z.number().int(),
    openingAmountOwedMinorUnits: z.number().int(),
    closingAmountOwedMinorUnits: z.number().int(),
    entries: z.array(SupplierStatementEntrySchema),
});
